export const YUZ_LEYLA = [
  {
    id: "yl001",
    metin: "{{ad}}, yüzüne bakarken bir derinlik hissettim. {{soru}} konusunda şunu söyleyeyim: gözlerin her şeyi anlatıyor. O gözlerde hem acı hem umut var — ikisi bir arada. Bu denge, güçlü bir ruhun işareti.\n\nO gücü küçümseme. Acıyı taşıyan ama umudunu kaybetmeyen insan — en güçlü insandır. Sen o insansın.",
    tema: "goz"
  },
  {
    id: "yl002",
    metin: "{{ad}}, alnındaki o ince çizgiye bak. Düşünen bir zihin bu. {{soru}} konusunda çok düşünüyorsun — bazen gereğinden fazla.\n\nZihni sustur, kalbi dinle. Cevap orada. Çok düşünmek bazen netliği değil, karmaşayı getirir. Sessizlikte zihin durulur — ve durulmuş zihin daha net görür.",
    tema: "zihin"
  },
  {
    id: "yl003",
    metin: "{{ad}}, çene yapın güçlü. Bu irade ve kararlılık demek. {{soru}} konusunda bir karar verdin mi henüz? Çenen bana evet diyebileceğini söylüyor.\n\nİnan kendine. İrade bir kastır — kullandıkça güçlenir. O iradeyi harekete geçir. Karar vermek bile başlı başına bir güç eylemidir.",
    tema: "irade"
  },
  {
    id: "yl004",
    metin: "{{ad}}, elmacık kemiklerin belirgin. Yüz okumada bu sosyal güç ve çevre demek. {{soru}} konusunda çevren sana yardımcı olacak.\n\nDoğru insanlarla bağlantıda kal. Çevre bir kaza değil, bir seçimdir. Seni büyüten insanlarla kal, küçültenlerden uzaklaş.",
    tema: "sosyal"
  },
  {
    id: "yl005",
    metin: "{{ad}}, gözlerinin rengi ve parıltısı bana çok şey söylüyor. {{soru}} konusunda içinde yanan bir ateş var — sönmemiş, sadece küçülmüş.\n\nO ateşi besle, körükle. Küçük ateş bile büyük karanlığı aydınlatır. Senin ateşin küçülmüş ama sönmemiş — bu çok önemli bir fark.",
    tema: "ates"
  },
  {
    id: "yl006",
    metin: "{{ad}}, kaşların şekline bak. Yay gibi kıvrılmış — bu sezgisel bir zihin demek. {{soru}} konusunda mantığından önce sezgine güven.\n\nİlk his genellikle doğrudur. Sezgi, birikmiş deneyimin sessiz dilidir. O dili dinle — çok şey söylüyor.",
    tema: "sezgi"
  },
  {
    id: "yl007",
    metin: "{{ad}}, dudaklarının şekli bana şefkat ve empati söylüyor. {{soru}} konusunda başkalarına çok şefkat gösteriyorsun, kendine az.\n\nBu dengeyi değiştir. Kendinle de nazik ol. Başkalarına verdiğin anlayışın onda birini kendine ver — izle ne değişiyor.",
    tema: "sefkat"
  },
  {
    id: "yl008",
    metin: "{{ad}}, burnunun şekline bak — güçlü ve belirgin. Yüz okumada bu liderlik ve iş zekası demek. {{soru}} konusunda iş ve kariyer alanında güçlü bir hamle vakti.\n\nÖne çık. Liderlik fırsatı kapıda — onu görmek için hazır ol. Lider doğmaz, lider adım atarak olunur.",
    tema: "kariyer"
  },
  {
    id: "yl009",
    metin: "{{ad}}, kulak yapın bana ilginç bir şey söylüyor — dinleyici bir ruh. {{soru}} konusunda şu an dinleme vakti. Konuşmaktan çok dinle.\n\nCevap sana söylenecek. Bazen en büyük bilgelik, susmasını bilmektir. Dinleyen insan çok şey öğrenir — konuşan ise sadece bildiğini tekrarlar.",
    tema: "dinleme"
  },
  {
    id: "yl010",
    metin: "{{ad}}, alnının genişliği bana entelektüel bir kapasite gösteriyor. {{soru}} konusunda bu zekayı kullan. Çözüm karmaşık değil — sadece farklı bir bakış açısı gerekiyor.\n\nBazen en zor sorunların en basit çözümleri vardır. O basitliği görmek için zihni karmaşadan arındırmak lazım.",
    tema: "zeka"
  },
  {
    id: "yl011",
    metin: "{{ad}}, yüzündeki simetri ilginç. Tam simetrik değil — hiçbir yüz değil zaten. Ama bu asimetri karakterini gösteriyor. {{soru}} konusunda mükemmel olmaya çalışma.\n\nGerçek ol. Mükemmellik bir hedef değil, bir yanılsamadır. Gerçeklik ise her zaman mükemmellikten daha etkileyicidir.",
    tema: "gerceklik"
  },
  {
    id: "yl012",
    metin: "{{ad}}, gözlerinin altındaki o hafif iz — yorgunluğu mu gösteriyor, derin düşünceyi mi? {{soru}} konusunda hem yorgunsun hem de çok düşünüyorsun.\n\nDur, nefes al, sonra devam et. Dinlenmiş zihin daha net düşünür. Yorgunlukla alınan kararlar genellikle pişmanlıkla sonuçlanır.",
    tema: "dinlenme"
  },
  {
    id: "yl013",
    metin: "{{ad}}, yüzün bana bir hikaye anlatıyor — uzun, zorlu ama güzel bir hikaye. {{soru}} konusunda bu hikayenin en güzel bölümü henüz yazılmadı.\n\nKalem sendedir. Ne yazacağını sen seçiyorsun. Geçmiş bölümleri değiştiremezsin — ama bundan sonrakini yazabilirsin.",
    tema: "hikaye"
  },
  {
    id: "yl014",
    metin: "{{ad}}, çene çizgine bak — güçlü ama esnek. Bu sertlik ve yumuşaklığın dengesi. {{soru}} konusunda ne zaman sert ne zaman yumuşak olacağını bil.\n\nİkisi de gerekli — ama doğru zamanda. Yanlış zamanda sertlik kırar, yanlış zamanda yumuşaklık kaybettirir. O zamanlamayı öğren.",
    tema: "denge"
  },
  {
    id: "yl015",
    metin: "{{ad}}, gözlerinde bir arayış var. {{soru}} konusunda aradığın şey dışarıda değil içeride.\n\nAynaya bak — gerçekten bak. Cevap orada. Dışarıda aradığımız şeylerin çoğu, içeride zaten vardır — sadece görmek için içe dönmek gerekir.",
    tema: "ic_arayis"
  },
  {
    id: "yl016",
    metin: "{{ad}}, yüzünün genel enerjisi bana su elementi söylüyor — akışkan, derin, değişken. {{soru}} konusunda akışa bırak kendini.\n\nZorlamak suyu durdurmuyor, yavaşlatıyor. Bıraktığında daha hızlı akar. Su her engelin etrafından dolaşır — sen de öyle.",
    tema: "akis"
  },
  {
    id: "yl017",
    metin: "{{ad}}, kaşların arasındaki o nokta — üçüncü göz bölgesi. Bu bölgede güçlü bir enerji hissediyorum. {{soru}} konusunda sezgilerin çok güçlü şu an.\n\nOnlara kulak ver. Üçüncü göz mantığın değil, bilgeliğin penceresidir. O pencereden bak — farklı bir dünya görürsün.",
    tema: "ucuncu_goz"
  },
  {
    id: "yl018",
    metin: "{{ad}}, gülümsediğinde gözlerin de gülümseyen türdensin — bunu hissedebiliyorum. {{soru}} konusunda o gülümsemeyi kaybetme.\n\nNeşe en güçlü kalkan. Gülümseyen insan hem kendini hem çevresini iyileştirir. O gülümsemeyi koru — zorlu günlerde bile.",
    tema: "nes"
  },
  {
    id: "yl019",
    metin: "{{ad}}, yüzündeki o asil duruş bana güçlü bir karakter söylüyor. {{soru}} konusunda karakterini koru. Baskı altında bile eğilme.\n\nÇünkü sen eğilecek türden değilsin. Karakterin bir ağır yük altında da aynı kalırsa — işte o zaman gerçek karakterdir.",
    tema: "karakter"
  },
  {
    id: "yl020",
    metin: "{{ad}}, gözlerinin derinliğinde bir bilgelik var — yaşından fazla. {{soru}} konusunda bu bilgeliği kullan.\n\nİçindeki yaşlı ruh sana doğru yolu gösterecek. O ruhun sesini dinle — tecrübe konuşuyor. Yaşla gelen bilgelik, kitaplardan öğrenilemez.",
    tema: "bilgelik"
  },
  {
    id: "yl021",
    metin: "{{ad}}, yüzünün sol tarafı sağ tarafından biraz farklı. Sol taraf iç dünyayı, sağ taraf dış dünyayı gösterir. {{soru}} konusunda iç ve dış dünyan arasında bir gerilim var.\n\nUyumu bul. İçinde düşündüğün ile dışarıya yansıttığın arasındaki mesafeyi kapat. O mesafe enerji tüketir.",
    tema: "uyum"
  },
  {
    id: "yl022",
    metin: "{{ad}}, alnındaki çizgiler bana bir harita gibi görünüyor. {{soru}} konusunda hayatın bir harita gibi — bazı yollar kapalı, bazıları açık.\n\nAçık olanı seç, kapalıya çarpma. Kapalı kapıyı zorlamak yerine açık kapıyı aramak — bu akıllıca bir strateji.",
    tema: "yol"
  },
  {
    id: "yl023",
    metin: "{{ad}}, yüzündeki o dinginlik beni şaşırttı. İçinde fırtına var ama dışarıda sakinsin. {{soru}} konusunda bu dinginliği ödünç ver kendine — içindeki fırtınayı da sakinleştir.\n\nDış dinginlik içe yansır zamanla. Dışarıda sakin kalmak, içeriyi de sakinleştirir. Bu paradoks ama gerçek.",
    tema: "dinginlik"
  },
  {
    id: "yl024",
    metin: "{{ad}}, gözlerinin rengi ne olursa olsun — o parıltı özel. {{soru}} konusunda o parıltıyı söndüren ne varsa hayatından çıkar.\n\nIşığını koru. Parıltını söndüren şeyler — insanlar, durumlar, alışkanlıklar — hepsini gözden geçir. Işığın değerli.",
    tema: "isik"
  },
  {
    id: "yl025",
    metin: "{{ad}}, yüzün bana şunu söylüyor: sen sandığından çok daha güzelsin — içten ve dıştan. {{soru}} konusunda kendini küçümseme alışkanlığını bırak.\n\nDeğerini bil. Değerini bilmeyen başkalarının belirlediği fiyatla yaşar. Sen kendi değerini belirle — ve o değer, şu an düşündüğünden çok daha yüksek.",
    tema: "deger"
  }
];